<template>
  <div class="quick-login">
    <input-field v-for="i in 6" :id="i" :key="i" pattern="[0-9]{1}" maxlength="1" @keyup="validate">
    </input-field>
  </div>
</template>

<script>
import InputField from './InputField.vue';
import { loginService } from '@/app/features/login/login.service';
import { sessionUtils } from '@/mixins/session-utils';

export default {
  name: 'QuickLoginInput',
  components: { InputField },
  mixins: [sessionUtils],
  props: {
    userName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      magicCode: ['', '', '', '', '', '']
    };
  },
  computed: {},
  watch: {
    magicCode: {
      immediate: true,
      handler(val) {
        const pat = /\d{6}/;
        if (pat.test(val.join(''))) {
          //make call to api to log this user in (if code is valid)
          this.doMagicLogin();
        }
      }
    }
  },
  methods: {
    validate(e) {
      const idx = e.target.id - 1;
      if (e.key === 'Backspace' || e.key === 'Delete') {
        this.$set(this.magicCode, idx, '');
      } else {
        const val = e.target.value;
        const pattern = /[0-9]{1}/;

        const nextId = parseInt(e.target.id) + 1;
        if (!pattern.test(val)) {
          //reset character if its not numeric
          document.querySelector(`[id='${e.target.id}']`).value = '';
        } else {
          this.$set(this.magicCode, idx, parseInt(val));
          if (nextId <= 6) {
            document.querySelector(`[id='${nextId}']`).focus();
          }
        }
      }
    },
    doMagicLogin() {
      const code = this.magicCode.join('');
      loginService.doMagicLogin(this.userName, code).then(response => {
        this.setAccessTokenAndRedirectToHome(response);
      });
    }
  }
};
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/colors';
@import '../styles/defaults';

.quick-login {
  display: flex;
  //flex: 1;
  flex-basis: 100%;
  justify-content: center;
  min-height: 350px;
  background-color: $white;
  .input-container .input-field {
    background-color: $mid-blue;
    height: 75px;
    width: 75px;
    margin: 0 5px;
    font-size: 50px;
    border-radius: 5px;
    text-align: center;
  }
}
</style>
